import { useQuery, UseQueryResult } from "react-query";
import { AxiosError } from "axios";
import getTeamAccessDetails, {
  TeamAccessDetailsResponse,
} from "../api/get-team-access-details";

const useGetTeamAccessDetails = (
  teamId: string
): UseQueryResult<TeamAccessDetailsResponse, AxiosError> => {
  return useQuery<TeamAccessDetailsResponse, AxiosError>({
    queryKey: ["teamAccessDetails", teamId],
    queryFn: () => getTeamAccessDetails(teamId),
  });
};

export default useGetTeamAccessDetails;
